<template>
    <tr @click="highlightItem()" class="os-order-row" :class="{ 'green lighten-2' : highlighted }">
        <template v-for="(field, index) in fieldsMain">
            <field-input
				:key="field.id"
    			ref="childinput"
    			:assignment_type="type+'item'"
    			:assignment_id="row.id"
				:availableassignments="availableassignments ? availableassignments[field.id] : null"
    			:class="{'pl-3' : !index}"
    			:column="(field.id === productField.id ? 'product_id' : null)"
    			:edit="editing"
				:editDisabled="editDisabled"
    			:field="field"
    			:inlineEdit="inlineEdit"
    			:inlineSave="inlineSave"
    			:keyedFieldvalues="scopeFieldvalues"
                :overrideConfig="(overrides ? overrides[field.id] : null)"
    			:rowindex="rowindex"
    			:setDefault="(!viewform || !row.id)"
    			:singleLine="true"
    			:table="true"
    			:value="scopeFieldvalues[field.id][rowindex]"
    			:viewform="viewform"
                @click.stop
    			@inputChanged="inputChanged"></field-input>
        </template>

		<td
		:class="priceOverrides['pricetype'].visibility === 'visible' ? 'px-2' : 'px-0'"
		:style="{ minWidth: (priceOverrides['pricetype'].visibility === 'visible' && (editing || editingprice) ? '130px;' : '')}"
		v-if="$store.state.pricetypes.length > 1">

			<span v-if="editDisabled || (!editing && !editingprice)" class="subheading">
				<template v-if="priceOverrides['pricetype'].visibility === 'visible'">
					{{ (keyedPriceTypes[row.pricetype_id] ? keyedPriceTypes[row.pricetype_id].name : '') }}
				</template>
			</span>
			<v-select
				:disabled="priceOverrides['pricetype'].read_only"
				v-show="priceOverrides['pricetype'].visibility === 'visible'"
				item-text="name"
				item-value="id"
  				label="Price Type"
				ref="fieldinput"
				required
				single-line
    			v-else
				:items="pricetypes"
				:rules="[(!!scopepricetype) || 'This field is required']"
				:value="scopepricetype"
                @click.stop
				@input="pricetypeChanged"
			></v-select>
		</td>
		<td :class="priceOverrides['price'].visibility === 'visible' ? 'px-2' : 'px-0'" :style="{ minWidth: (priceOverrides['price'].visibility === 'visible' && (editing || editingprice) ? '142px;' : '')}">
			<span v-if="editDisabled || (!editing && !editingprice)" class="subheading">
				<template v-if="priceOverrides['price'].visibility === 'visible'">
					{{ row.price | pricefilter }}
				</template>
			</span>
			<v-text-field
				:disabled="priceOverrides['price'].read_only"
				v-show="priceOverrides['price'].visibility === 'visible'"
				label="Price"
				prefix="£"
				ref="fieldinput"
				required
				single-line
    			v-else
				:append-icon="(price.fixed ? 'lock' : null)"
				:readonly="price.fixed"
				:rules="[(value) => {
					const pattern = /^[0-9]+(\.[0-9]{1,2})?$/;
					return !!value && pattern.test(value) || 'Invalid price.';
				}]"
				:value="scopeprice"
                @click.stop
				@input="priceChanged"></v-text-field>
		</td>
		<td :class="priceOverrides['total'].visibility === 'visible' ? 'px-2' : 'px-0'" :style="{ minWidth: (priceOverrides['price'].visibility === 'visible' && (editing || editingprice) ? '142px;' : '')}">
			<span v-if="editDisabled || (!editing && !editingprice)" class="subheading">
				<template v-if="priceOverrides['total'].visibility === 'visible'">
					{{ row.total | pricefilter }}
				</template>
			</span>
			<v-text-field
				:disabled="priceOverrides['total'].read_only"
				v-show="priceOverrides['total'].visibility === 'visible'"
				label="Total"
				prefix="£"
				readonly
				single-line
    			v-else
				:value="rowPrice"
                @click.stop></v-text-field>
		</td>

		<td class="px-0" :width="(!viewform ? '40px' : (inlineSave ? '115px' : '80px'))" v-if="!editDisabled">
			<v-slide-y-reverse-transition mode="out-in">
				<div :key="'transition-'+editing+'-'+editingprice" class="fill-height">
					<template v-if="viewform">
						<template v-if="inlineEdit">
							<template v-if="!editingprice">
								<v-btn icon class="ma-0 os-btn os-hover-btn" :class="{'os-touch-device' : touchdevice}" @click.stop="editingprice = true;" v-if="showEditButton">
									<v-icon color="info">mdi-circle-edit-outline</v-icon>
								</v-btn>
							</template>
							<template v-else>
								<v-btn icon class="ma-0 os-btn" @click.stop="savePrice" v-if="inlineSave">
									<v-icon color="success">mdi-check-outline</v-icon>
								</v-btn>
								<v-btn icon class="ma-0 os-btn" @click.stop="cancelPrice">
									<v-icon color="error">mdi-close-circle-outline</v-icon>
								</v-btn>
							</template>
						</template>
						<template v-else>
							<template v-if="!editing">
								<v-btn icon class="ma-0 os-btn os-rowhover-btn" @click.stop="$emit('setEdit', row.id, true)" v-if="!editDisabled">
									<v-icon color="info">mdi-circle-edit-outline</v-icon>
								</v-btn>
							</template>
							<template v-else>
								<v-btn icon class="ma-0 os-btn" @click.stop="saveRow" v-if="inlineSave">
									<v-icon color="success">mdi-check-outline</v-icon>
								</v-btn>
								<v-btn v-if="row.id" icon class="ma-0 os-btn" @click.stop="cancelEdit">
									<v-icon color="error">mdi-close-circle-outline</v-icon>
								</v-btn>
							</template>
						</template>
						<v-btn icon class="ma-0 os-btn os-rowhover-btn float-right" @click.stop="deleteOrderitem" v-if="!editDisabled && canEditItems">
							<v-icon color="error">mdi-delete-outline</v-icon>
						</v-btn>
					</template>
					<template v-else>
						<v-btn icon class="ma-0 os-btn os-rowhover-btn" @click.stop="$emit('deleteOrderitem', rowindex)" v-if="!editDisabled">
							<v-icon color="error">mdi-delete-outline</v-icon>
						</v-btn>
					</template>
				</div>
			</v-slide-y-reverse-transition>
		</td>

        <template v-for="field in fieldsStatus">
            <field-input
				:key="field.id"
    			ref="childinput"
    			:assignment_type="type+'item'"
    			:assignment_id="row.id"
				:availableassignments="availableassignments ? availableassignments[field.id] : null"
    			:column="(field.id === productField.id ? 'product_id' : null)"
    			:edit="editing"
    			:field="field"
    			:inlineEdit="inlineEdit"
    			:inlineSave="inlineSave"
    			:keyedFieldvalues="scopeFieldvalues"
                :overrideConfig="(overrides ? overrides[field.id] : null)"
    			:rowindex="rowindex"
    			:setDefault="(!viewform || !row.id)"
    			:singleLine="true"
    			:table="true"
    			:value="scopeFieldvalues[field.id][rowindex]"
    			:viewform="viewform"
				:editDisabled="editDisabled"
    			@inputChanged="inputChanged"></field-input>
        </template>
    </tr>
</template>

<script>
	import { mapGetters } from 'vuex';
    import FieldInput from '../shared/FieldInput';
	import FieldValue from '../shared/FieldValue';
	import Shortcodes from '../../mixins/Shortcodes';
	import fielvalue from '../../mixins/fieldvalue';

    export default {
        components: {
            'field-input': FieldInput,
			'field-value': FieldValue
        },
		mixins: [Shortcodes, fielvalue],
        computed: {
			...mapGetters([
                'fieldShortcodes',
		    	'keyedCustomers',
				'keyedPriceTypes',
				'keyedProducts'
			  ]),
			orderpriceField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_orderpriceField : this.$store.getters.orderpriceField;
			},
			priceField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_priceField : this.$store.getters.priceField;
			},
			pricetypeField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_pricetypeField : this.$store.getters.pricetypeField;
			},
			totalField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_totalField : this.$store.getters.totalField;
			},
			touchdevice() {
				return "ontouchstart" in document.documentElement;
			},
			showEditButton() {
				return !this.inlineEdit || this.priceOverrides['pricetype'].visibility === 'visible' || this.priceOverrides['price'].visibility === 'visible';
			},
			iCanEditPrice() {
				if(this.priceOverrides['pricetype'].visibility === 'visible' && this.priceOverrides['pricetype'].read_only === false)
					return true;
				if(this.priceOverrides['price'].visibility === 'visible' && this.priceOverrides['price'].read_only === false)
					return true;
				return false;
			},
            fieldsMain() {
                return this.fields.filter(field => {
                    return (field.type === 'status' || ['price_type', 'price', 'total'].indexOf(field.internal_name) > -1 ? false : true);
                });
            },
            fieldsStatus() {
                return this.fields.filter(field => {
                    return (field.type === 'status' ? true : false);
                });
            },
            highlighted() {
                if(!this.department){
                    return false;
                }else if(this.department.configuration.itemHighlight && this.highlight){
                    return true;
                }else if(!this.department.configuration.itemHighlight || !this.department.configuration.autoHighlight){
                    return false;
                }else{
                    let matched = false;
                    for(let y = 0, group; group = this.department.conditiongroups[y]; y++){
                        let count = group.conditions.length,
                            matches = 0;
                        for(let z = 0, condition; condition = group.conditions[z]; z++){
                            let value = this.scopeFieldvalues[condition.field_id][this.rowindex];

                            if(value){
                                let matched2 = false;

                                if(condition.comparator === 'before'){
                                    if(new Date(value.value) <= new Date(condition.value))
                                        matched2 = true;
                                }else if(condition.comparator === 'after'){
                                    if(new Date(value.value) >= new Date(condition.value))
                                        matched2 = true;
                                }else if(condition.comparator === '>'){
                                    if(parseFloat(value.value) > parseFloat(condition.value))
                                        matched2 = true;
                                }else if(condition.comparator === '<'){
                                    if(parseFloat(value.value) < parseFloat(condition.value))
                                        matched2 = true;
                                }else if(condition.comparator === '='){
                                    if(
                                        condition.value === value.value ||
                                        (
                                            value.format === 'array' &&
                                            value.value.indexOf(condition.value) > -1
                                        )
                                    ){
                                        matched2 = true;
                                    }
                                }else if(condition.comparator === '!='){
                                    if(
                                        condition.value !== value.value ||
                                        (
                                            value.format === 'array' &&
                                            value.value.indexOf(condition.value) === -1
                                        )
                                    ){
                                        matched2 = true;
                                    }
                                }else if(condition.comparator === 'IN'){
                                    if(value.format !== 'array'){
                                        if(condition.value.indexOf(value.value) > -1){
                                            matched2 = true;
                                        }
                                    }else{
                                        for(let w = 0, valueval; valueval = value.value[w]; w++){
                                            if(condition.value.indexOf(valueval) > -1){
                                                matched2 = true;
                                            }
                                        }
                                    }
                                }else if(condition.comparator === 'contains'){
									if(typeof value.value === 'string' && value.value.includes(condition.value)){
                                        matched2 = true;
                                    }
								}

                                if(matched2){
                                    matches++;
                                    break
                                }
                            }
                        }
                        if(count === matches){
                            matched = true;
                            break;
                        }
                    }
					if(!this.department.conditiongroups.length)
						matched = true;

					return (matched ? 'auto' : false);
                }
            },
            inlineEdit() {
                return (this.department && this.department.configuration.inlineEdit && this.row.id ? true : false);
            },
            keyedFields() {
				return _.keyBy(this.fields, 'id');
            },
			price () {
				let returnprice = null;
				if(this.setprices && this.iCanEditPrice && (!this.viewform || this.iCan('edit', 'Orders'))){
					if(this.scopeFieldvalues[this.productField.id][this.rowindex] && this.scopeFieldvalues[this.productField.id][this.rowindex].value > 0 && this.keyedProducts[this.scopeFieldvalues[this.productField.id][this.rowindex].value]){
						let prices = this.keyedProducts[this.scopeFieldvalues[this.productField.id][this.rowindex].value].prices;
						if(this.scopeFieldvalues[this.customerField.id].value && this.keyedCustomers[this.scopeFieldvalues[this.customerField.id].value]){
							prices = this.keyedCustomers[this.scopeFieldvalues[this.customerField.id].value].prices.filter(price => {
								if(price.product_id === this.scopeFieldvalues[this.productField.id][this.rowindex].value)
									return true;
								return false;
							}).concat(prices);
						}

						let mostmatches = 0,
							base = null;
						for(let x = 0, price; price = prices[x]; x++){
							let matches = 0;
							// if(price.pricetype_id === this.scopepricetype || this.scopepricetype == "null"){
								for(let y = 0, condition; condition = price.conditions[y]; y++){
									if(this.scopeFieldvalues[condition.field_id]){
										let value = (this.scopeFieldvalues[condition.field_id].orderitem && this.scopeFieldvalues[condition.field_id][this.rowindex] ? this.scopeFieldvalues[condition.field_id][this.rowindex].value : this.scopeFieldvalues[condition.field_id].value);
										if(condition.value === value)
											matches++;
									}
								}
								if(matches === price.conditions.length){
									if(matches > mostmatches || (price.conditions.length === 0 && !returnprice) || (matches === mostmatches && price.customer_id && !returnprice.customer_id)){
										returnprice = Object.assign({}, price);
										mostmatches = matches;
									}
								}
							// }
						}
						if(!mostmatches && base)
							returnprice = base;
					}
				}
				if(!returnprice)
					returnprice = { price: null };
				return returnprice;
			},
			pricetypes () {
				return this.$store.state.pricetypes.filter(pricetype => pricetype.assignment_type === this.type);
			},
			rowPrice () {
				let pricetype = this.keyedPriceTypes[this.scopepricetype],
					calc = null,
					value = null;

				if(pricetype)
					calc = pricetype.calculation;				

				if(!!calc){
					if(this.scopeFieldvalues){
						value = this.replaceShortcodes({
							value: calc,
							rowindex: this.rowindex,
							keyedFieldValues: this.scopeFieldvalues,
							decorate: false,
							assignment_type: this.type
						});
						if(value)
							value = parseFloat(value).toFixed(2)
					}
				}

				return value;
			},
			scopeFieldvalues () {
				let values = _.cloneDeep(this.keyedFieldvalues);

				for(let x = 0, value; value = this.scopevalues[x]; x++){
					Object.assign(values[value.field_id][this.rowindex], value);
				}

				return values;
			}
        },
        data() {
            return {
                defaultValue:{
                    value: null
                },
				editingprice: false,
				scopeprice: this.row.price,
				scopepricetype: (this.row.pricetype_id ? this.row.pricetype_id.toString() : null),
				scopevalues: [],
            }
        },
		filters: {
  			pricefilter: function (value) {
				if(!value) return '';
    			return '£'+parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  			}
		},
		methods: {
			cancelEdit() {
				this.scopevalues = [];
				this.scopeprice = this.row.price;
				this.scopepricetype = (this.row.pricetype_id ? this.row.pricetype_id.toString() : null);
				this.$emit('setEdit', this.row.id, false);
			},
			cancelPrice() {
				this.scopeprice = this.row.price;
				this.scopepricetype = (this.row.pricetype_id ? this.row.pricetype_id.toString() : null);
				this.editingprice = false;
			},
			deleteOrderitem() {
				if(this.row.id){
					if(this.iCan('edit', 'Orders')){
						Swal.fire({
							title: "Are you sure?",
							text: "Once deleted, you will not be able to undo this action.",
							type: "warning",
							allowOutsideClick: false,
							showCancelButton: true,
							reverseButtons: true,
							confirmButtonColor: '#d33',
							confirmButtonText: 'Yes, delete it!'
						})
						.then((result) => {
							if (result.value) {
								this.$store.dispatch('set', { name: 'processing', value: true });
								axios.delete('/api/orderitem/'+this.row.id)
								.then(response => {
									Swal.fire({
										title: response.data.message,
										type: 'success',
										timer: 1200,
										showConfirmButton: false
									});
									this.$emit('deleteOrderitem', this.rowindex);
									
									if(response.data.log)
										this.$store.dispatch('addOrderLog', { id: this.order_id, log: response.data.log });
										
								}).catch(e => {
									Swal.fire({
										title: 'Unable to delete product row',
										type: 'error',
										timer: 1500,
										showConfirmButton: false
									});
									this.errors.push(e.data);
								}).then(() => {
									this.$store.dispatch('set', { name: 'processing', value: false });
								});
							}
						});
					}
				}else{
					this.$emit('deleteOrderitem', this.rowindex);
				}
			},
            highlightItem() {
                if(this.iCan('edit', 'Orders') && this.row.id && this.department && this.department.configuration.itemHighlight && this.highlighted !== 'auto')
                    this.$emit('highlightItem', this.row.id);
            },
			inputChanged($event) {
                let field = this.keyedFields[$event.field_id];

				if(this.viewform && !this.inlineEdit && (field.type !== 'status' || !this.row.id)){
					let value = _.cloneDeep($event),
						index = _.findIndex(this.scopevalues, ['field_id', value.field_id]);

					if(index > -1){
						this.scopevalues.splice(index, 1, value);
					}else{
						this.scopevalues.push(value);
					}

					if(!this.editing)
						this.$emit('setEdit', this.row.id, true);
				}else{
					this.$emit('OrderChanged', $event, this.rowindex);
				}
			},
			priceChanged(price) {
				if(this.viewform && this.scopeprice !== price){
					this.scopeprice = price;

					if(this.inlineEdit){
						if (!this.editingprice) this.editingprice = true;
					}else{
						if (!this.editing) this.$emit('setEdit', this.row.id, true);
					}
					
					let valueindex = _.findIndex(this.scopevalues, ['field_id', this.priceField.id]);
					if(valueindex > -1){
						this.scopevalues[valueindex].value = parseFloat(price).toFixed(2);
					}else{
						this.scopevalues.push({ field_id: this.priceField.id, value: parseFloat(price).toFixed(2), pricefield: true });
					}

				}else if(!this.viewform && this.row.price !== price){
					this.$emit('priceChanged', price, this.rowindex);
				}
			},
			pricetypeChanged(pricetype) {
				if(this.viewform && this.scopepricetype !== pricetype){
					this.scopepricetype = pricetype;

					if(this.inlineEdit){
						if (!this.editingprice) this.editingprice = true;
					}else{
						if (!this.editing) this.$emit('setEdit', this.row.id, true);
					}

					let valueindex = _.findIndex(this.scopevalues, ['field_id', this.pricetypeField.id]);
					if(valueindex > -1){
						this.scopevalues[valueindex].value = pricetype;
					}else{
						this.scopevalues.push({ field_id: this.pricetypeField.id, value: pricetype, pricefield: true });
					}
				}else if(!this.viewform && this.row.pricetype_id !== pricetype){
					this.$emit('pricetypeChanged', pricetype, this.rowindex);
				}
			},
			savePrice() {
                if(this.iCan('edit', 'Orders')){
    				let valid = true;
    				for(let x = 0, input; input = this.$refs.fieldinput[x]; x++){
    					if(!input.validate())
    						valid = false;
    				}
    				if(valid){
                        this.$store.dispatch('set', { name: 'processing', value: true });
    					axios.post('/api/orderitem/price', {
    						id: this.row.id,
    						pricetype_id: this.scopepricetype,
    						price: this.scopeprice,
    						total: this.rowPrice
    					})
                        .then(
                            response => {
    							this.$emit('OrderChanged', [], this.rowindex, response.data.orderitem.pricetype_id, response.data.orderitem.price, response.data.orderitem.total, response.data.orderitem.id);
    							this.editingprice = false;
								this.$store.dispatch('setSnack', { state: 'success', text: response.data.message });
								if(response.data.log)
									this.$store.dispatch('addOrderLog', { id: response.data.orderitem.order_id, log: response.data.log });
                            }
                        )
                        .catch(e => {
    						this.$store.dispatch('setSnack', { state: 'error', text: 'Unable to save price' });
                        }).then(() => {
    						this.$store.dispatch('set', { name: 'processing', value: false });
    					});
    				}
                }
			},
			saveRow() {
                if(this.iCan('edit', 'Orders')){
    				let valid = true,
    					product_id = null;
    				for(let x = 0, comp; comp = this.$refs.childinput[x]; x++){
    					if(comp.field.id === this.productField.id)
    						product_id = comp.scopevalue.value;
    					if(comp.$refs.fieldinput && !comp.$refs.fieldinput.validate())
    						valid = false;
    				}
    				for(let x = 0, input; input = this.$refs.fieldinput[x]; x++){
    					if(!input.validate())
    						valid = false;
    				}

    				if(valid){
						let data = new FormData(),
							scopevalues = _.cloneDeep(this.scopevalues);
							
						for(let x = 0, value; value = scopevalues[x]; x++){
							if(value.value && typeof value.value === 'object' && typeof value.value.name === 'string'){
								data.append('files[]', value.value);
								// scopevalues[x].value = { name: value.value.name };
								scopevalues[x].value = value.value.name;
							}else if(typeof value.value === 'undefined'){
								scopevalues[x].value = null
							}
						}
						data.append('order_id', this.order_id);
						data.append('pricetype_id', this.scopepricetype);
						data.append('price', this.scopeprice);
						data.append('product_id', product_id);
						data.append('fieldvalues', JSON.stringify(scopevalues));
						if(this.row.id)
							data.append('id', this.row.id);
						if(this.rowPrice)
							data.append('total', this.rowPrice);
						
                        this.$store.dispatch('set', { name: 'processing', value: true });
    					axios.post('/api/orderitem', data)
                        .then(
                            response => {
    							let values = (response.data.orderitem.fieldvalues ? response.data.orderitem.fieldvalues : []);
								this.scopevalues = [];
    							this.$emit('OrderChanged', values, this.rowindex, response.data.orderitem.pricetype_id, response.data.orderitem.price, response.data.orderitem.total, response.data.orderitem.id);
								this.$store.dispatch('setSnack', { state: 'success', text: response.data.message });
								if(response.data.log)
									this.$store.dispatch('addOrderLog', { id: response.data.orderitem.order_id, log: response.data.log });
                            }
                        )
                        .catch(e => {
    						this.$store.dispatch('setSnack', { state: 'error', text: 'Unable to save price' });
                        }).then(() => {
    						this.$store.dispatch('set', { name: 'processing', value: false });
    					});
				    }
                }
			}
		},
		mixins: [Shortcodes, fielvalue],
        props: [
			'availableassignments',
			'customerField',
            'department',
			'editing',
			'editDisabled',
            'fields',
            'highlight',
			'keyedFieldvalues',
			'row',
			'rowindex',
			'order_id',
			'overrides',
			'priceOverrides',
			'productField',
			'setprices',
			'viewform',
			'inlineSave',
			'canEditItems',
			'type'
        ],
        watch: {
			price: function(price, oldprice) {
				if(!_.isEqual(price, oldprice) && this.setprices){
					this.priceChanged(price.price);
					if(this.row.pricetype_id !== price.pricetype_id)
						this.pricetypeChanged(price.pricetype_id)
				}
			},
			row: {
				handler: function(row) {
					if(!this.editingprice){
						this.scopeprice = row.price;
						this.scopepricetype = (row.pricetype_id ? row.pricetype_id.toString() : null);
					}
				},
				deep: true
			},
			rowPrice: function(price) {
				if(!this.viewform){
					this.$emit('OrderChanged', [], this.rowindex, false, false, price, this.row.id);
				}else if(this.inlineEdit && !this.editingprice){
                    this.$store.dispatch('set', { name: 'processing', value: true });
					axios.post('/api/orderitem/price', {
						id: this.row.id,
						total: price
					})
                    .then(
                        response => {
							this.$emit('OrderChanged', [], this.rowindex, false, false, response.data.orderitem.total, response.data.orderitem.id);
							this.$store.dispatch('setSnack', { state: 'success', text: response.data.message });
							if(response.data.log)
								this.$store.dispatch('addOrderLog', { id: response.data.orderitem.order_id, log: response.data.log });
                        }
                    )
                    .catch(e => {
						this.$store.dispatch('setSnack', { state: 'error', text: 'Error updating the price total' });
                    }).then(() => {
						this.$store.dispatch('set', { name: 'processing', value: false });
					});
				}
			}
        }
    }
</script>

<style scoped lang="scss">
	.os-btn{
		position:relative;
		top:50%;
		transform:translateY(-50%);
	}
	.os-rowhover-btn,
	.os-hover-btn:not(.os-touch-device){
		display:none;
	}
    tr.os-order-row{
        border-bottom: 1px solid rgba(0,0,0,.12) !important;
    }
	tr:hover .os-rowhover-btn:not(.os-touch-device){
		display:inline-block;
	}

	td:hover+td+td+td .os-hover-btn,
	td+td:hover+td+td .os-hover-btn,
	td+td+td:hover+td .os-hover-btn,
	td+td+td+td:hover .os-hover-btn{
		display:inline-block;
	}
</style>
